import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/tools/proposals")({
  beforeLoad: () => {
    throw redirect({ to: "/en/tools/suppliers", statusCode: 301 });
  },
});
